import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavServiceService } from 'src/app/services/nav-service.service';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})

export class StoreComponent implements OnInit {

  pageTitle: any = '';


  constructor(
    public navService: NavServiceService
  ){}

  ngOnInit(){
    this.navService.titleSub.subscribe(res => {
      // console.log(res);
      this.pageTitle = res;
    })
  }


}